// extracted by mini-css-extract-plugin
export default {"btn":"skuQf9Tp","primary":"uUolKcqG","secondary":"Cv5bAQAz","ghost":"vBfuZSdL","sm":"S8CtfR3D","loading":"y9ExrfJ4","label":"nXEMmLUL"};